import { render } from "./SiKaoThreeView.vue?vue&type=template&id=7cbfce9f&scoped=true&ts=true"
import script from "./SiKaoThreeView.vue?vue&type=script&lang=ts"
export * from "./SiKaoThreeView.vue?vue&type=script&lang=ts"

import "./SiKaoThreeView.vue?vue&type=style&index=0&id=7cbfce9f&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbfce9f"]])

export default __exports__